const ERROR_CLASSES = 'bg-red-100 text-red-600'

const hasErrors = drop => {
  const errors = drop.attributes.bottle_cycle_errors || {}
  return Boolean(errors.no_store_error || errors.no_group_error || errors.no_fulfillment_availability_days_error)
}

const hasFailedReminder = reminders => reminders.some(x => x.attributes?.status === 'failed')

const hasNoOpenDates = drop => drop.attributes.lifecycle === 'upcoming' && drop.attributes.open_for_ordering === false

// Status badge for a drop row: the first matching condition wins.
export const dropStatus = (drop, reminders = []) => {
  if (hasErrors(drop)) return { label: 'Has errors', classes: ERROR_CLASSES }
  if (hasFailedReminder(reminders)) return { label: 'Reminder failed', classes: ERROR_CLASSES }
  if (hasNoOpenDates(drop)) return { label: 'No open dates', classes: 'bg-yellow-100 text-yellow-700' }
  return { label: 'Active', classes: 'bg-green-100 text-green-800' }
}
